const agrupamento = [
    { label: 'Mensal', value: 'Mensal' },
    { label: 'Trimestre', value: 'Trimestre' },
    { label: 'Semestre', value: 'Semestre' },
    { label: 'Anual', value: 'Anual' }
]

module.exports = agrupamento;